import { BaseReducer } from '@identic/api';
import { SynonymState, SynonymInitialState, SynonymActions } from './synonym.state';

export function SynonymReducer(state: SynonymState = SynonymInitialState, action: any): SynonymState {
  return BaseReducer(state, action, SynonymActions);
}
// console.log(`%cSynonymReducer::ngOnInit`, 'background:yellow');
